import React, { createContext, useContext } from "react";
import useAnalyticsHook from "../../hooks/Dashboard/useAnalytics";

export const AnalyticsContext = createContext();

export const AnalyticsProvider = ({ children }) => {
  const analytics = useAnalyticsHook();
  
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);